module.exports = __webpack_public_path__ + "assets/34d7d1b1872036e70aeb92226f9bf4ef.mp3";